
export default {
  props: {
    to: {
      type: [Object, String],
      default: () => ({ name: 'signup' }),
    },
  },
}
